export const props2attrs = <T extends Record<string, unknown>>(attrs: T) =>
  Object.fromEntries(Object.entries(attrs).map(([name, value]) => [kebabCase(name), value]))

export const kebabCase = (str: string) => str.replace(/([A-Z])/g, "-$1").toLowerCase()
